import BOPaginationTable from './BOPaginationTable';

export default BOPaginationTable;
